import { gql } from '@apollo/client';
import {SelectOptionType, SELECT_OPTION_FIELDS} from 'graphql/types/SelectOptionType'

export const GET_FEE_ITEM_LIST_FOR_OPTIONS = gql`
    query SettlementFeeItemQuery($businessScenarioCode: Long) {
        allOptions: getAllSettlementFeeItem(businessScenarioCode: $businessScenarioCode) {
            ...SelectOptionFields
        }
    }
    ${SELECT_OPTION_FIELDS}
`;

export interface AllFeeItemResponse {
    allOptions: SelectOptionType[];
}
